import { ThemeUICSSObject } from '@apia/theme';
import { collapsiblePanel } from './defaultView';
/* IMPORT HERE */

const infoModal: ThemeUICSSObject = {
  minWidth: '550px',
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  ...collapsiblePanel,
  button: {
    cursor: 'pointer',
  },
  table: {
    width: '100%',
    span: {
      fontWeight: 'bold',
    },
    button: {
      boxShadow: 'none',
      color: 'palette.text.primary',
      background: 'inherit',
    },

    'tr > td:first-of-type': {
      width: '50%',
    },
    '.table__buttons': {
      display: 'flex',
      gap: 3,
    },
  },

  '.allPermissions': {
    background: 'palette.background.paper',
    display: 'flex',
    flexDirection: 'row',
    gap: 3,
    alignItems: 'center',
    borderRadius: 'default',
    border: '1px solid',
    borderColor: 'palette.gray.800',
    p: 4,
    width: '100%',
    div: { width: '100%' },
    select: { width: '100%' },
  },

  '.permissions__list': {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    ul: {
      borderRadius: 'default',
      border: '1px solid',
      borderColor: 'palette.gray.800',
      background: 'palette.background.paper',
    },
  },

  '.doc_info_table_container': {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    background: 'palette.background.paper',
    padding: 3,
    borderRadius: 'default',
    border: '1px solid',
    borderColor: 'palette.gray.800',
  },

  '.doc_info_table': {
    width: '100%',
    maxHeight: '310px',
    overflowY: 'auto',
    boxSizing: 'border-box',
    position: 'relative',

    th: {
      position: 'sticky',
      top: 0,
      backgroundColor: 'palette.background.paper',
      zIndex: 2,
      border: 'none',
      borderBottom: '1px solid #ccc',
      padding: '8px',
      textAlign: 'left',
      width: '50%',
    },

    tbody: {
      '.selected': {
        background: 'palette.gray.900',
      },
      td: {
        padding: 3,
        borderBottom: '1px solid #ececec',
        verticalAlign: 'top',
      },
      '.iconButton': {
        border: 'none',
      },
    },

    button: {
      justifyContent: 'start',
      width: '100%',
    },
  },

  '.versions_table': {
    'thead tr th:first-of-type, tbody tr td:first-of-type': {
      width: '100px',
      textAlign: 'center',
    },
  },

  '.versions_table__scroll': {
    maxHeight: '310px',
    overflowY: 'auto',
  },

  '.versions_table__show_more': {
    alignSelf: 'center',
  },
};

export default infoModal;
